export default {
	META: 'meta', // 原数据
	LOADING: 'loading',
	CURRENT_USER: 'currentUser', // 当前用户信息
	MESSAGE: 'message', // 全局成功、失败信息
	BRAND: 'brand', // 
	BRAND_FACTORY: 'brandFactory',
	LEAVE_BLOCK_UPDATE: 'leave.block.update',
};